import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight, Globe } from 'lucide-react';

export const OneMinuteSolarSection: React.FC = () => {
  return (
    <section
      className="spaq-solar py-20 sm:py-24 lg:py-28 bg-[#F3F8FA] text-[#122331]"
      aria-labelledby="spaq-solar-heading"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Narrative / Text: On PC placed on the right column (~5 cols) */}
          <div className="lg:col-span-5 lg:order-2 space-y-6">
            <span className="text-xs font-bold tracking-[0.2em] text-[#526372] uppercase">
              SIMULATION
            </span>

            <div className="space-y-3">
              <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-[#122331]">
                1minute solar
              </h2>
              <h3
                id="spaq-solar-heading"
                className="text-2xl sm:text-[30px] font-bold text-[#122331] leading-snug"
              >
                導入の判断を、<br />
                もっと速く。
              </h3>
            </div>

            <p className="text-base text-[#526372] leading-relaxed">
              自家消費と経済性を、導入前に見通す。
            </p>

            {/* Desktop CTAs (hidden on mobile, shown on lg+) */}
            <div className="pt-2 hidden lg:flex flex-col items-start gap-4">
              <a
                href="https://1minute.spaq.ltd/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-base font-bold text-[#087C96] hover:text-[#23A6C4] hover:underline underline-offset-8 transition-colors group"
              >
                <span>シミュレーターを試す</span>
                <ArrowUpRight
                  size={18}
                  className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  aria-hidden="true"
                />
              </a>

              <Link
                to="/products/1minute-solar"
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#526372] hover:text-[#122331] transition-colors"
              >
                <span>製品について</span>
                <ArrowRight size={14} aria-hidden="true" />
              </Link>
            </div>
          </div>

          {/* Real App Screenshot in Modern Window Frame: On PC placed on the left column (~7 cols) */}
          <div className="lg:col-span-7 lg:order-1">
            <div className="bg-white rounded-2xl shadow-xl border border-[#DCE4EA] overflow-hidden group transition-shadow duration-300 hover:shadow-2xl">
              {/* Minimal Browser Window Titlebar */}
              <div className="px-4 py-3 bg-[#F8FAFC] border-b border-[#E2E8F0] flex items-center justify-between gap-3 text-xs text-slate-500">
                <div className="flex items-center gap-2">
                  <span className="w-3 h-3 rounded-full bg-[#EF4444]/80 inline-block" />
                  <span className="w-3 h-3 rounded-full bg-[#F59E0B]/80 inline-block" />
                  <span className="w-3 h-3 rounded-full bg-[#10B981]/80 inline-block" />
                </div>
                <div className="flex items-center gap-1.5 px-3 py-1 bg-white rounded-md border border-[#E2E8F0] text-[11px] font-mono text-slate-600 truncate max-w-[280px] sm:max-w-[360px] shadow-sm">
                  <Globe size={12} className="text-[#087C96] shrink-0" />
                  <span className="truncate">https://1minute.spaq.ltd/</span>
                </div>
                <span className="text-[10px] font-semibold text-[#087C96] tracking-wider uppercase hidden sm:inline">
                  PRO ANALYTICS
                </span>
              </div>

              {/* Real App Interface Screenshot */}
              <div className="relative bg-slate-50 overflow-hidden">
                <img
                  src="/assets/products/1minute-solar-app-preview.png"
                  alt="1minute solar 自家消費型太陽光シミュレーターの実際の試算・並列比較画面"
                  className="w-full h-auto object-cover object-top block"
                  width="555"
                  height="635"
                />
              </div>
            </div>

            {/* Caption */}
            <div className="text-left mt-2.5 text-[11px] text-[#526372] font-normal flex items-center justify-between">
              <span>画面イメージ（1minute solar 実際の試算画面）</span>
              <a
                href="https://1minute.spaq.ltd/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#087C96] hover:underline inline-flex items-center gap-1 text-[11px]"
              >
                <span>実画面をWebで開く</span>
                <ArrowUpRight size={12} />
              </a>
            </div>

            {/* Mobile CTAs: Displayed below the screen on mobile, natural reading order */}
            <div className="mt-6 flex flex-col items-start gap-4 lg:hidden">
              <a
                href="https://1minute.spaq.ltd/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-base font-bold text-[#087C96] hover:text-[#23A6C4] transition-colors"
              >
                <span>シミュレーターを試す</span>
                <ArrowUpRight size={18} aria-hidden="true" />
              </a>

              <Link
                to="/products/1minute-solar"
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#526372]"
              >
                <span>製品について</span>
                <ArrowRight size={14} aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
